// import KITCHEN_ROUTES from './kitchen.routes';
import MAIN_STORE_ROUTES from './main-store.routes';

export default [
  // ...KITCHEN_ROUTES,
  ...MAIN_STORE_ROUTES
];
